import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'boolean'
})
export class BooleanPipe implements PipeTransform {
    constructor(private translationService: TranslateService) {}

    transform(value: boolean, acceptNull = true): string {
        if (acceptNull && value === null) {
            return '-';
        }
        return this.translationService.instant(value ? 'LABELS.YES' : 'LABELS.NO');
    }

}
